var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSocialYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "-3 -5 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7115 1.56476C13.5502 0.952892 13.0773 0.470562 12.4777 0.305804C11.3821 0 6.99984 0 6.99984 0C6.99984 0 2.61774 0 1.5222 0.29421C0.934047 0.458793 0.449635 0.952979 0.288306 1.56476C0 2.68232 0 5 0 5C0 5 0 7.32936 0.288306 8.43524C0.449806 9.04702 0.922512 9.52935 1.52228 9.69411C2.62928 10 7.00001 10 7.00001 10C7.00001 10 11.3821 10 12.4777 9.70579C13.0774 9.54112 13.5502 9.05879 13.7117 8.44701C13.9999 7.32936 13.9999 5.01177 13.9999 5.01177C13.9999 5.01177 14.0115 2.68232 13.7115 1.56476ZM5.60463 7.14115V2.85885L9.2487 5L5.60463 7.14115Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialYoutube);
export default __webpack_public_path__ + "static/media/icon-social-youtube.ead374fee51b59d067d9080fea91df0b.svg";
export { ForwardRef as ReactComponent };